import enumeration from "./enumeration";

const TransactionType = {
  TOPUP: "TOPUP",
  SALE: "SALE",
  RETURN: "RETURN",
  MIXED: "MIXED",
  REDEEM: "REDEEM",
  REMOVE: "REMOVE",
  ISSUE: "ISSUE",
  ISSUE_FOC: "ISSUE_FOC",
  REMOVE_FOC: "REMOVE_FOC",
};

export default enumeration(TransactionType);
